// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2VT72","content":"RecentSearches_content__1eRfJ"};